var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',{staticClass:"mx-4 mt-4 mb-10"},[_c('legend',{staticClass:"text-gray-700 caption"},[_vm._v("Weitere Suchkriterien")]),_c('div',{staticClass:"flex flex-wrap mt-4"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }